const link = {
  saas: {
    home: "/",
    contact: "/contact",
    login: "/login",
    register: "/register",
  },
};

export default link;
